import moment from "moment";

export function getPublicUrl(url) {
  return process.env.PUBLIC_URL + url;
}

const crossesThreshold = (offsetY, thresholdOffsetY) => {
  return offsetY < thresholdOffsetY;
};

export function wasElementedVisited(elementRef, windowHeightPctBuffer = 0.1) {
  if (elementRef.current) {
    const rect = elementRef.current.getBoundingClientRect();

    // appear when the element's center is positioned
    const elementCenter = (rect.top + rect.bottom) / 2.0;
    const buffer = window.innerHeight * windowHeightPctBuffer;
    const appearOnThreshold = window.innerHeight / 2.0 + buffer;

    return crossesThreshold(elementCenter, appearOnThreshold);
  }

  return false;
}

export const mergeRefs = (...refs) => {
  return (node) => {
    for (const ref of refs) {
      ref.current = node;
    }
  };
};
